/**
 * Constants
 *
 * Application-wide constants and configuration
 */

import type { LanguageCode } from '@/types/user';

/** Supported languages with display names */
export const LANGUAGES: Record<LanguageCode, { name: string; nativeName: string; flag: string }> = {
  ko: { name: 'Korean', nativeName: '한국어', flag: '🇰🇷' },
  en: { name: 'English', nativeName: 'English', flag: '🇺🇸' },
  ja: { name: 'Japanese', nativeName: '日本語', flag: '🇯🇵' },
  zh: { name: 'Chinese', nativeName: '中文', flag: '🇨🇳' },
  es: { name: 'Spanish', nativeName: 'Español', flag: '🇪🇸' },
} as const;

/** List of supported language codes */
export const LANGUAGE_CODES: LanguageCode[] = ['ko', 'en', 'ja', 'zh', 'es'];

/** Default language */
export const DEFAULT_LANGUAGE: LanguageCode = 'ko';

/** Application name */
export const APP_NAME = 'Talksy';

/** Application tagline */
export const APP_TAGLINE = 'Talk easy';

/** Routes */
export const ROUTES = {
  LOGIN: '/login',
  AUTH_CALLBACK: '/auth/callback',
  ONBOARDING: '/onboarding',
  USERNAME_SETUP: '/setup-username',
  HOME: '/',
  SEARCH: '/search',
  // Channel routes
  CHANNEL_LIST: '/channels',
  CHANNEL_ROOM: '/channels/:id',
  CHANNEL_INVITE: '/channel/invite/:code',
  // DM routes
  DM_LIST: '/dm',
  DM_ROOM: '/dm/:dmId',
  // Friend routes
  FRIENDS: '/friends',
  FRIEND_REQUESTS: '/requests',
  BLOCKED_USERS: '/blocked',
  // Settings routes
  SETTINGS: '/settings',
  PROFILE_EDIT: '/profile',
} as const;

/** Local storage keys */
export const STORAGE_KEYS = {
  SETTINGS: 'talksy-settings',
  AUTH: 'talksy-auth',
} as const;
